import axios from 'axios';
import qs from 'qs';
import cookie from '../cookieHelper/cookie'; 

export default function addUser(data, companyId) {
    const API_URL = `${process.env.REACT_APP_BASE_URL}/api/v1/company/${companyId}`;
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);

    return axios
        .post(API_URL, qs.stringify(data), {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        })
        .then(res => {
            // console.log('User added successfully:', res);
            return res;
        })
        .catch(err => {
            // console.error('Error adding user:', err);
            return err;
        });
}
